module.exports = __webpack_public_path__ + "img/treatments-directory-icon.5917d66f.svg";